import wx from 'weixin-js-sdk'
// 判断当前环境宿主对象
let _environment
const ua = window.navigator.userAgent.toLowerCase();
window.wx = wx

const matchResult = ua.match(/MicroMessenger/i)
// 小程序
if (window.__wxjs_environment === 'miniprogram') {
  _environment = 0
}
// 微信H5
else if (matchResult && matchResult[0] === 'micromessenger') {
  _environment = 1
}
// 普通浏览器
else {
  _environment = 2
}
export default _environment
